<template>
  <v-row>
    <v-col cols="6">
      <v-autocomplete
        class="input-text-size pt-0 pb-0"
        label="Bank"
        :value="editedItem.bankId"
        :items="bankList"
        item-text="bankName"
        item-value="_id"
        :error-messages="bankIdErrors"
        @change="handleBankChange"
        @blur="touch('bankId')"
      />
      <ClarionDateControl
        class="input-text-size pt-0 pb-0 mt-n2"
        v-model="editedItem.date"
        :isToggle="false"
        :isRequired="true"
        label="Date *"
      />
      <v-text-field
        class="input-text-size pt-0 pb-0 mt-n2"
        label="Check #"
        v-model.number="editedItem.checkNo"
        type="number"
        :error-messages="checkNoErrors"
        @input="touch('checkNo')"
        @blur="touch('checkNo')"
      />
      <v-textarea
        class="input-text-size mt-2"
        label="For What"
        v-model="editedItem.forWhat"
        outlined
        rows="5"
        no-resize
      />
    </v-col>
    <v-col cols="6">
      <v-text-field
        class="input-text-size pt-0 pb-0"
        label="To Whom (Payee)"
        v-model="editedItem.payee"
        :error-messages="payeeErrors"
        @input="touch('payee')"
        @blur="touch('payee')"
      />
      <v-currency-field
        class="input-text-size pt-0 pb-0 mt-n2"
        label="Amount"
        v-model="editedItem.amount"
        :error-messages="amountErrors"
        @input="touch('amount')"
        @blur="touch('amount')"
      />
      <ClarionDateControl
        class="input-text-size pt-0 pb-0 mt-n2"
        v-model="editedItem.paidDate"
        :isToggle="false"
        label="Paid Date"
      />
    </v-col>
  </v-row>
</template>

<script>
import {
  mapGetters,
  mapMutations,
} from 'vuex';
import { required } from 'vuelidate/lib/validators';
import ClarionDateControl from '../../common/ClarionDateControl.vue';
import { amountToNumber } from '../../../util/shared/vue-global';

const bankListCrudKey = 'treasurersChecksBankList';

export default {
  name: 'TreasurersChecksDialog',
  components: {
    ClarionDateControl,
  },
  props: {
    baseCrudKey: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters('base/crud', ['item', 'items']),
    bankList() {
      return this.items(bankListCrudKey) || [];
    },
    editedItem: {
      get() {
        return this.item(this.baseCrudKey) || {};
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    bankIdErrors() {
      const errors = [];
      const v = this.$v && this.$v.editedItem && this.$v.editedItem.bankId;
      if (!v || !v.$dirty) return errors;
      if (!v.required) errors.push('Bank is required.');
      return errors;
    },
    checkNoErrors() {
      const errors = [];
      const v = this.$v && this.$v.editedItem && this.$v.editedItem.checkNo;
      if (!v || !v.$dirty) return errors;
      if (!v.required) errors.push('Check # is required.');
      return errors;
    },
    payeeErrors() {
      const errors = [];
      const v = this.$v && this.$v.editedItem && this.$v.editedItem.payee;
      if (!v || !v.$dirty) return errors;
      if (!v.required) errors.push('Payee is required.');
      return errors;
    },
    amountErrors() {
      const errors = [];
      const v = this.$v && this.$v.editedItem && this.$v.editedItem.amount;
      if (!v || !v.$dirty) return errors;
      if (!v.required) errors.push('Amount is required.');
      if (!v.minValue) errors.push('Amount must be greater than 0.');
      return errors;
    },
  },
  methods: {
    ...mapMutations('base/crud', ['setItem']),
    touch(field) {
      const v = this.$v && this.$v.editedItem && this.$v.editedItem[field];
      if (v && typeof v.$touch === 'function') v.$touch();
    },
    handleBankChange(bankId) {
      const selectedBank = this.bankList.find((b) => b._id === bankId) || {};
      this.editedItem = {
        ...this.editedItem,
        bankId,
        bankName: selectedBank.bankName || '',
      };
      this.touch('bankId');
    },
  },
  validations: {
    editedItem: {
      bankId: { required },
      checkNo: { required },
      payee: { required },
      amount: {
        required,
        minValue: (value) => amountToNumber(value) > 0,
      },
    },
  },
};
</script>
